import { render } from "./ContainerTitle.vue?vue&type=template&id=2c2fa600&ts=true"
import script from "./ContainerTitle.vue?vue&type=script&lang=ts"
export * from "./ContainerTitle.vue?vue&type=script&lang=ts"

import "./ContainerTitle.vue?vue&type=style&index=0&id=2c2fa600&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__